<template>
<el-dialog :visible.sync="dialogVisible" :before-close="closeModal" :show-close="false">
    <div class="img-info mt-4">
        <img
            crossorigin="anonymous"
            class="img-fluid w-100"
            :src="`${urlApi}/${info}`"
            alt=""
        >
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">

        <a class="mr-3 pointer" @click="closeModal">
            Fechar
        </a>
    </span>
</el-dialog>
</template>

<script>
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        info: {
            required: true,
            default: []
        }
    },
    data() {
        return {
            urlApi: process.env.VUE_APP_ROOT_API,
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.img-info {
    max-height: 500px;
    overflow: auto;
}
</style>
